module.exports = __webpack_public_path__ + "img/PorkPortugal.1ed1702c.png";